import React from "react";
import { Link } from "react-router-dom";

/** Reusable promotional banner with hover zoom and gold ring. fullBleed spans edge-to-edge. */
export const PromoBanner = ({ image, to, testid, ariaLabel, fullBleed = false, overlay = null }) => (
  <section className={fullBleed ? "pt-2 sm:pt-3 pb-3 sm:pb-4" : "max-w-7xl mx-auto px-4 sm:px-6 pt-2 sm:pt-3 pb-4 sm:pb-5"} data-testid={testid}>
    <Link
      to={to}
      data-testid={`${testid}-link`}
      aria-label={ariaLabel}
      className="group relative block overflow-hidden ring-1 ring-gold/25 hover:ring-gold/60 transition-all duration-500"
    >
      <img
        src={image}
        alt={ariaLabel}
        loading="lazy"
        className="w-full h-auto object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.03]"
      />
      <span className="absolute inset-0 bg-maroon/0 group-hover:bg-maroon/10 transition-colors duration-500" />
      {overlay && <span className="absolute bottom-3 left-3 sm:bottom-6 sm:left-8 z-10">{overlay}</span>}
    </Link>
  </section>
);
